import { apiGet } from './client';

/** Server-driven pricing coefficients for running-estimate UI (GET /api/v1/pricing-catalog). */
export function listPricingCatalog() {
  return apiGet('/api/v1/pricing-catalog');
}
